export enum KID_SORT {
  NAME = 'name',
  TITLE = 'title',
  LAST_LOGIN_AT = 'lastLoginAt',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
}
